module.exports = __webpack_public_path__ + "media/images/icons/info-eae643b86b40b0d8a38f9f9d0151af16.svg";